export default __webpack_public_path__ + "static/media/keyvisual-hildesheim.95cda01b.jpg";